import {b2b} from 'top20common/distribution/constants/scopes';
import auth from 'top20common/distribution/services/auth';
import languageService from 'top20common/distribution/services/languages';
import * as contextUtils from 'top20common/distribution/themes/utils';
import Vue from 'vue';
import GetTextPlugin from 'vue-gettext';
import Router from 'vue-router';

import store from '@/store';

import translations from '../../../translations.json';

const RegisterContainer = () => import('@/pages/register/RegisterContainer');
const RegisterFinishContainer = () => import('@/pages/register/RegisterFinishContainer');
const CandidateRegisterContainer = () => import('@/pages/register/CandidateRegisterContainer');
const LoginContainer = () => import('@/pages/login/LoginContainer.vue');
const EmailConfirmationContainer = () => import('@/pages/email-confirmation/EmailConfirmationContainer.vue');
const ResetPasswordConfirmContainer = () =>
  import('@/pages/reset-password/confirmation/ResetPasswordConfirmContainer.vue');
const ResetPasswordContainer = () => import('@/pages/reset-password/ResetPasswordContainer.vue');
const ChangePasswordPage = () => import('@/pages/change-password/ChangePasswordPage.vue');
const SettingsPage = () => import('@/pages/settings/SettingsPage.vue');
const RouteNotFound = () => import('top20common/components/RouteNotFound');

Vue.use(GetTextPlugin, {
  availableLanguages: {
    en_US: 'English',
    zh_Hans: 'Chinese'
  },
  defaultLanguage: languageService.getCurrent() || 'en_US',
  translations: translations,
  silent: true
});

const vue = new Vue();
const title = contextUtils.getCurrentTitle();
const loginTitle = vue.$gettext('Login');
const registerTitle = vue.$gettext('Register');
const verifyEmailTitle = vue.$gettext('Verify Email');
const resetPasswordTitle = vue.$gettext('Reset Password');
const changePasswordTitle = vue.$gettext('Change Password');
const settingsTitle = vue.$gettext('Settings');

const routes = [
  {path: '/accounts/', redirect: {name: 'login-employer'}},
  {
    path: '/:lang?/accounts/register/candidate',
    name: 'register-candidate',
    component: CandidateRegisterContainer,
    meta: {
      title: `${registerTitle} - ${title}`,
      isOpen: true
    }
  },
  {
    path: '/:lang?/accounts/register',
    name: 'register-employer',
    component: RegisterContainer,
    meta: {
      title: `${registerTitle} - ${title}`,
      isOpen: true
    }
  },
  {
    path: '/:lang?/accounts/register/candidate/finish',
    name: 'register-candidate-finish',
    component: RegisterFinishContainer,
    meta: {
      title: `${registerTitle} - ${title}`,
      isOpen: true
    }
  },
  {
    path: '/:lang?/accounts/login',
    name: 'login-employer',
    component: LoginContainer,
    meta: {title: `${loginTitle} - ${title}`, isOpen: true}
  },
  {
    path: '/:lang?/accounts/login/candidate',
    name: 'login-candidate',
    component: LoginContainer,
    meta: {title: `${loginTitle} - ${title}`, isOpen: true}
  },
  {
    path: '/:lang?/accounts/email-confirmation/:key/',
    name: 'email-confirmation',
    component: EmailConfirmationContainer,
    meta: {title: `${verifyEmailTitle} - ${title}`}
  },
  {
    path: '/:lang?/accounts/reset-password/:uid/:token/',
    name: 'reset-password-employer-confirmation',
    component: ResetPasswordConfirmContainer,
    meta: {title: `${resetPasswordTitle} - ${title}`, isOpen: true}
  },
  {
    path: '/:lang?/accounts/reset-password/candidate/:uid/:token/',
    name: 'reset-password-candidate-confirmation',
    component: ResetPasswordConfirmContainer,
    meta: {title: `${resetPasswordTitle} - ${title}`, isOpen: true}
  },
  {
    path: '/:lang?/accounts/reset-password/',
    name: 'reset-password-employer',
    component: ResetPasswordContainer,
    meta: {title: `${resetPasswordTitle} - ${title}`, isOpen: true}
  },
  {
    path: '/:lang?/accounts/reset-password/candidate/',
    name: 'reset-password-candidate',
    component: ResetPasswordContainer,
    meta: {title: `${resetPasswordTitle} - ${title}`, isOpen: true}
  },
  {
    path: '/:lang?/accounts/change-password/',
    name: 'changePassword',
    component: ChangePasswordPage,
    meta: {title: `${changePasswordTitle} - ${title}`}
  },
  {
    path: '/:lang?/accounts/settings/',
    name: 'settings',
    component: SettingsPage,
    meta: {title: `${settingsTitle} - ${title}`, scopes: [b2b]}
  },
  {
    path: '/refer/:referral_code?/',
    name: 'refer',
    redirect: to => {
      return {name: 'register-candidate', query: {referral_code: to.params.referral_code}};
    },
    meta: {isOpen: true}
  },
  {
    path: '/register/:external_id?/',
    name: 'external-code-register',
    beforeEnter(to, from, next) {
      next({name: 'register-candidate', query: {...to.query, candidate: to.params.external_id}});
    },
    meta: {isOpen: true}
  },
  {
    path: '*',
    component: RouteNotFound
  }
];

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_PREFIX || '/',
  routes,
  linkActiveClass: 'is-active'
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || title;
  auth.beforeEachRouteAuth(router, store, to, from, next);
});

router.afterEach((to, from) => {
  router.app.$mam.trackPageView(to);
});

export default router;
